import React from "react";
import { MapPinOff } from "lucide-react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "./ui/alert-dialog";
import { GPS_REQUIRED_MESSAGE } from "../lib/gps";

/**
 * Phase 132 — shown whenever a field photo is captured without a GPS fix (location off, permission denied,
 * no satellite / network fix). The photo is discarded; "Try again" re-opens the camera.
 */
export function GpsRequiredDialog({ open, onOpenChange, onRetry, testId = "gps-required-dialog" }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid={testId}>
        <AlertDialogHeader>
          <div className="mx-auto sm:mx-0 flex h-11 w-11 items-center justify-center rounded-full bg-[hsl(var(--warning))]/10">
            <MapPinOff className="h-5 w-5 text-[hsl(var(--warning))]" aria-hidden="true" />
          </div>
          <AlertDialogTitle data-testid={`${testId}-title`}>GPS location required</AlertDialogTitle>
          <AlertDialogDescription data-testid={`${testId}-message`}>{GPS_REQUIRED_MESSAGE}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testId}-cancel`}>Cancel</AlertDialogCancel>
          {onRetry && (
            <AlertDialogAction onClick={onRetry} data-testid={`${testId}-retry`}>Try again</AlertDialogAction>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
